
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gYj7Sar9h6DMXLds6iI89_vY9bNAFyXC4ONEd_WbQLq8Meta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index42_6PAE8gDBn0YU7uETIbPosmwHYuuvTJ6GSX1Vw2kMMeta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchlIa4eYuP5OqAR6y5q4coUX_45Z0ENr4nL0rqWPu0n1iTYMeta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexmB_45XowLj1euP8CuD2fzpQfwUGUmdPP0_JiYCSv23L0YMeta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93RsZ37PmMOtfsyHMICXreqJEOFNMUnj5a7uOkquoemTQMeta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexgWxaSHmEW3TLPXKEld2RUbEGEJcNe6fQqRENrIo4u6AMeta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93RR8_459q35ANsP_1thRTzBnhZvHW3Fmk_jUhDaihJsQaoMeta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexOpbVOvRWVaFVIAd7Ly99AYTx1N1Vak07QUmAIQaQUf8Meta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93QgAUfYxNfTia1bo2w4qHAiGctapEIF3ilsxXQcf2hO0Meta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexr_45jABrn_f5ayAia44dxjvLZcb341OAYyg5CtXhLOqOYMeta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexk6UUn3sQ278722sYnu3fHysadBawXHJ52WjX3DTlXFcMeta } from "/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexgWxaSHmEW3TLPXKEld2RUbEGEJcNe6fQqRENrIo4u6AMeta || {},
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexOpbVOvRWVaFVIAd7Ly99AYTx1N1Vak07QUmAIQaQUf8Meta || {},
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexr_45jABrn_f5ayAia44dxjvLZcb341OAYyg5CtXhLOqOYMeta || {},
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexk6UUn3sQ278722sYnu3fHysadBawXHJ52WjX3DTlXFcMeta || {},
    component: () => import("/codebuild/output/src928953544/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]